import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import { useTranslation } from "react-i18next";

function Home2() {
  const { t } = useTranslation();

  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              {t("intro.titleBefore")}{" "}
              <span className="purple"> {t("intro.titleHighlight")} </span>{" "}
              {t("intro.titleAfter")}
            </h1>

            <p className="home-about-body">
              {t("intro.paragraph1").split("Adrian Xavier")[0]}
              <b className="purple">Adrian Xavier</b>
              {t("intro.paragraph1").split("Adrian Xavier")[1]}
              <br />
              <br />
              {t("intro.paragraph2").split("TypeScript")[0]}
              <i>
                <b className="purple">
                  TypeScript, React.js, React Native, Node.js, UX/UI Design
                </b>
              </i>
              {t("intro.paragraph2").split("UX/UI Design")[1]}
              <br />
              <br />
              {t("intro.paragraph3").split("Ignite Corporation")[0]}
              <a
                href="https://www.ignitecorp.com.br"
                target="_blank"
                rel="noopener noreferrer"
                className="purple ignite-link"
              >
                <b>Ignite Corporation</b>
              </a>
              {t("intro.paragraph3").split("Ignite Corporation")[1]}
              <br />
              <br />
              {t("intro.paragraph4")}
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
